import { render, staticRenderFns } from "./PartDetailCard.vue?vue&type=template&id=572057e2&scoped=true"
import script from "./PartDetailCard.vue?vue&type=script&lang=ts"
export * from "./PartDetailCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572057e2",
  null
  
)

export default component.exports